import instance from '../../api/instance'
const path = '/wv/inquiry_ratings'

export default {
    async create(inquiry_rating) {
        let body = {inquiry_rating}
        return instance().post(path, body)
    }
}
